angular.module('app.entity.actions').controller('ChangeRevisionStrategyController', [
    '$scope',
    'CrdConfigurationService',
    'ShareCrfSDK',
    'RecordService',
    'ShareCrfApiErrorCodes',
    'RevisionCount',
    'EntityMenu',
    function($scope, CrdConfigurationService, ShareCrfSDK, RecordService, ShareCrfApiErrorCodes, RevisionCount, EntityMenu) {
        var vm = this;

        var state = $scope.ngDialogData.state;

        vm.error = null;
        vm.loading = false;

        var revisionStrategy = RecordService.getRevisionStrategy();
        vm.selectedStrategy = revisionStrategy ? revisionStrategy[state.getId()] : null;

        var orderedStrategies = [
            'all',
            'required',
        ];

        Array.prototype.push.apply(orderedStrategies, Object.keys(CrdConfigurationService.get().tags));

        vm.strategies = state.getFieldsType().sort(function(strategyA, strategyB) {
            return orderedStrategies.indexOf(strategyA) - orderedStrategies.indexOf(strategyB);
        });

        vm.updateStrategy = function() {
            vm.loading = true;

            var sdkParams = {
                id: RecordService.getId(),
                stateId: state.getId(),
                strategy: vm.selectedStrategy,
            };

            return ShareCrfSDK.revision.updateStrategy(sdkParams)
                .then(function(recordUpdatedStrategy) {
                    RecordService.setRevisionStrategy(recordUpdatedStrategy);

                    return RevisionCount.loadFromRecord(RecordService.getId());
                })
                .then(function() {
                    return $scope.closeThisDialog(vm.selectedStrategy);
                })
                .then(function() {
                    return EntityMenu.reload();
                })
                .catch(function(error) {
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                })
                .finally(function() {
                    vm.loading = false;
                });
        };
    },
]);
